import React from 'react';
import { Icon } from '@types';

export const DocumentError = ({ customStyles, handleClick }: Icon) => {
	return (
		<svg
			className={customStyles}
			onClick={handleClick}
			xmlns="http://www.w3.org/2000/svg"
			width="21"
			height="28"
			fill="none"
			viewBox="0 0 21 28"
		>
			<path
				fill="#E22339"
				d="M17.5 26.25c.93 0 1.75-.766 1.75-1.75v-14h-6.125A2.591 2.591 0 0110.5 7.875V1.75h-7c-.984 0-1.75.82-1.75 1.75v21c0 .984.766 1.75 1.75 1.75h14zm-4.375-17.5h6.07c-.054-.11-.11-.273-.218-.383l-6.344-6.344c-.11-.109-.274-.164-.383-.218v6.07c0 .492.383.875.875.875zM3.5 0h8.531c.656 0 1.367.328 1.86.82l6.289 6.29c.492.492.82 1.202.82 1.859V24.5a3.49 3.49 0 01-3.5 3.5h-14C1.531 28 0 26.469 0 24.5v-21A3.49 3.49 0 013.5 0zm7 12.25c.438 0 .875.438.875.875v6.125c0 .492-.438.875-.875.875a.864.864 0 01-.875-.875v-6.125c0-.438.383-.875.875-.875zm1.313 10.5c0 .766-.602 1.313-1.313 1.313-.766 0-1.313-.547-1.313-1.313 0-.71.547-1.313 1.313-1.313.71 0 1.313.602 1.313 1.313z"
			></path>
		</svg>
	);
};
